export function extractNonArraysFromObj<T extends NonNullable<unknown>>(x: T) {
    return Object.fromEntries(Object.entries(x).filter(([k,v])=>!(!v || v instanceof Array)));
}
export function extractNonArrays<T=unknown>(obj: T[]) {
    return obj.map(x=>typeof x==='object'?x?extractNonArraysFromObj(x):x:x);
}